<template>
  <div class="shotlist">
    <PageLoader :isActive="isLoading"/>
    <Nav :authRequired = "true"/>
    <div class="container mb-x0 shot-back-button-container">
      <div class="row shot-back-row">
        <div class="col d-flex justify-content-between mb-x2">
          <router-link :to="'/jobs/z' + zohoId" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </router-link>
          <button class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim" @click="showStickyFilters = !showStickyFilters" v-if="showFilterToggle">
            <span v-if="showStickyFilters">hide filters</span>
            <span v-else>show filters</span>
          </button>
        </div>
      </div>
    </div>
    <div class="container mb-x0" v-if="zohoError">
      <div class="row mb-x4">
        <div class="col">
          <div class="zero-notification uhoh mb-x4" >
            <div class="zero-notification-icon"></div>
            ZOHO Error: {{ zohoError }}
          </div>
        </div>
      </div>
    </div>
    <div class="container mb-x0" v-if="noShots">
      <div class="row mb-x4">
        <div class="col">
          <div class="zero-notification info mb-x4" >
            <div class="zero-notification-icon"></div>
            No shotlist available
          </div>
        </div>
      </div>
    </div>
    <div class="container mb-x0" v-if="!noShots">
      <div class="row mb-x2">
        <div class="col">
          <div class="h6">
            {{ eventData.event_name }}
          </div>
          <div class="mb-x4">
            <div class="d-flex justify-content-between align-items-center">
              <h2>{{ shotlistTitle }}</h2>
              <router-link :to="'/jobs/z' + zohoId + '/shots/create'" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline" v-if="userData.permissions[0] === '1'">
                <i class="fas fa-plus"></i><span class="mobile-hide-inline ml-x1">Add a Shot</span>
              </router-link>
            </div>
            <div class="italic color-grayscale-3" v-if="cachedon">
              cached on: {{ cachedon }} EST
              <button class="zero-btn zero-btn-tertiary" @click="getZohoShotlist(true)" v-if="userData.permissions[0] === '1'">refresh cache</button>
            </div>
          </div>
          <div class="row mb-x4">
            <div class="col">
              <div class="zero-tab" @click="toggleTab('assigned')" :class="activeTab == 'assigned' ? 'active-tab' : ''">
                Assigned <span class="zero-badge ml-x1">{{ assignedResults.length }}</span>
              </div>
            </div>
            <div class="col">
              <div class="zero-tab" @click="toggleTab('general')" :class="activeTab == 'general' ? 'active-tab' : ''">
                General <span class="zero-badge ml-x1">{{ generalResults.length }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ASSIGNED SHOTS -->
    <template v-if="activeTab == 'assigned' && !noShots && assignedResults.length > 0">
      <div class="container mb-x0 filters-container" :class="{ 'sticky-filters-container': showStickyFilters }">
        <div class="row mb-x2">
          <div class="col">
            <h6>Creatives</h6>
            <CreativesList zoho :creatives="eventData.creatives" filter @filterEmit="creativeFilter" :activeFilters="filteredCreatives"/>
          </div>
        </div>
        <div class="row mb-x2">
          <div class="col">
            <h6>Dates</h6>
            <DatesList v-if="eventData.days.length !== 0" :dates="eventData.days" @filterEmit="dateFilter" :activeFilters="filteredDates" zoho/>
          </div>
        </div>
      </div>
      <div class="container mb-x0" id="shotlist-container">
        <div class="row mb-x4">
          <div class="col-md-8 col-lg-6">
            <button class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim mb-x4" @click="jumpNow()" v-if="jobIsCurrent">
              Jump to Now
            </button>
            <div class="zero-card mb-x2" v-for="(shot, index) in filteredResults" :key="index" :id="'assigned-' + index">
              <div class="d-flex justify-content-between">
                <div>
                  <p class="shot-date" v-if="shot.Name && /\d/.test(shot.Name)">{{ getDayofWeek(shot.Name) }} {{ parseDate(shot.Name) }}</p>
                  <h5>{{ shot.START_TIME }} - {{ shot.END_TIME }}</h5>
                </div>
                <button class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim align-self-start" @click="toggleExpand(index)">
                  <i class="fas fa-chevron-down" v-show="!isExpanded[index]"></i>
                  <i class="fas fa-chevron-up" v-show="isExpanded[index]"></i>
                </button>
              </div>
              <CreativesList zoho includeName :creatives="shot.PHOTOG_Full_Name" />
              <div v-show="isExpanded[index]">
                <div class="shot-info-group" v-if="shot.LOCATION_VENUE_MEETING_FUNCTION_ROOM ">
                  <div class="shot-label">location</div>
                  <p>{{ shot.LOCATION_VENUE_MEETING_FUNCTION_ROOM }}</p>
                </div>
                <div class="shot-info-group" v-if="shot.EVENT_FUNCTION_NAME">
                  <div class="shot-label">event/session</div>
                  <p>{{ shot.EVENT_FUNCTION_NAME }}</p>
                </div>
                <div class="shot-info-group" v-if="shot.CONTACT">
                  <div class="shot-label">session contact</div>
                  <p>{{ shot.CONTACT }}</p>
                </div>
                <div class="shot-info-group" v-if="shot.ESTIMATED_TIME || shot.ANY_SPECIAL_DELIVERY_INSTRUCTIONS_REQUIREMENTS">
                  <div class="shot-label">details</div>
                  <div v-html="shot.ESTIMATED_TIME"></div>
                  <div v-html="shot.ANY_SPECIAL_DELIVERY_INSTRUCTIONS_REQUIREMENTS"></div>
                </div>
                <NoteEditor :zshotid="shot.id" :zid="zohoId" :appshotidprop="shot.appshotid" :notesProp="shot.usernote" :jwt="userToken" @noteSaved="updateShot($event,index, 'note')" class="mr-x2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- GENERAL SHOTS -->
    <template v-if="activeTab == 'assigned' && !noShots && filteredResults.length == 0">
      <div class="container mb-x0">
        <div class="row mb-x2">
          <div class="col">
            No assigned shots
          </div>
        </div>
      </div>
    </template>
    <template v-if="activeTab == 'general' && !noShots">
      <div class="container mb-x0">
        <div class="row mb-x4">
          <div class="col-md-8 col-lg-6">
            <div class="zero-card mb-x2" v-for="(shot, index) in generalResults" :key="index">
              <div class="d-flex">
                <div>
                  <ToDoClick :zshotid="shot.id" :zid="zohoId" :appshotidprop="shot.appshotid" :done="shot.usernote" :jwt="userToken" @checkMarked="updateShot($event,index, 'check')" class="mr-x2" />
                </div>
                <div>
                  <p class="shot-date" v-if="shot.Name && /\d/.test(shot.Name)">{{ getDayofWeek(shot.Name) }} {{ parseDate(shot.Name) }}</p>
                  <p class="shot-date" v-else>{{ shot.Name }}</p>
                  <h5 class="mb-x1">{{ shot.START_TIME }}</h5>
                  <div class="shot-info-group" v-if="shot.LOCATION_VENUE_MEETING_FUNCTION_ROOM ">
                    <div class="shot-label">location</div>
                    <p>{{ shot.LOCATION_VENUE_MEETING_FUNCTION_ROOM }}</p>
                  </div>
                  <div class="shot-info-group" v-if="shot.EVENT_FUNCTION_NAME">
                    <div class="shot-label">event/session</div>
                    <p>{{ shot.EVENT_FUNCTION_NAME }}</p>
                  </div>
                  <div class="shot-info-group" v-if="shot.CONTACT">
                    <div class="shot-label">session contact</div>
                    <p>{{ shot.CONTACT }}</p>
                  </div>
                  <div class="shot-info-group" v-if="shot.ESTIMATED_TIME || shot.ANY_SPECIAL_DELIVERY_INSTRUCTIONS_REQUIREMENTS">
                    <div class="shot-label">details</div>
                    <div v-html="shot.ESTIMATED_TIME"></div>
                    <div v-html="shot.ANY_SPECIAL_DELIVERY_INSTRUCTIONS_REQUIREMENTS"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- FABS -->
    <button @click="backToTop" class="zero-btn zero-btn-fab zero-btn-primary bottom-right">
      <i class="fas fa-arrow-up"></i>
    </button>
    <!-- modal town -->
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'
import CreativesList from '@/components/CreativesList.vue'
import DatesList from '@/components/DatesList.vue'
import PageLoader from '@/components/PageLoader.vue'
import ToDoClick from '@/components/ZohoToDoClick.vue'
import NoteEditor from '@/components/ZohoNoteEditor.vue'
import shared from '@/shared.js'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'home',
  components: {
    Nav,
    CreativesList,
    DatesList,
    PageLoader,
    ToDoClick,
    NoteEditor
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      zohoId: '',
      zohoData: '',
      eventData: {
        'event_name': '',
        'days': [],
        'location': '',
        'floorplan_path': ''
      },
      singleShotlist: '',
      singleShotlistConsole: '',
      shots: [],
      uploadCSVmodal: false,
      errors: {
        'file': ''
      },
      users: [],
      shotlistTitle: 'Shotlist',
      generalShots: false,
      filteredCreatives: [],
      filteredDates: [],
      filteredResults: [],
      generalResults: [],
      assignedResults: [],
      editNotes: false,
      noShots: false,
      activeTab: 'assigned',
      showStickyFilters: false,
      showFilterToggle: false,
      zohoError: '',
      cachedon: '',
      isExpanded: [],
      jobIsCurrent: false
    }
  },
  watch: {},
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.zohoid) {
      this.zohoId = this.$route.params.zohoid.slice(1)
      this.getZohoShotlist()
      // this.getUsers()
    }
    window.addEventListener('scroll', this.scrollpastfilters)
  },
  unmounted () {
    window.removeEventListener('scroll', this.scrollpastfilters)
  },
  methods: {
    getEvent () {
      axios
        .get(apiChoice + 'api/events/' + this.eventId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.eventData = response.data
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    getShotlist () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/events/' + this.eventId + '/shotlist', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.shots = response.data
          this.combineFilters()
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getGeneralShots () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/events/' + this.eventId + '/general', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.filteredResults = response.data
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getUsers () {
      axios
        .get(apiChoice + 'api/users', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          this.users = response.data
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },
    parseDate (timestamp, dateSegment = 0) {
      return shared.parseDate(timestamp, dateSegment, true)
    },
    amPmConvert (time) {
      return shared.amPmConvert(time)
    },
    creativeFilter (clickedCreative) {
      if (this.filteredCreatives.includes(clickedCreative)) {
        this.filteredCreatives = this.filteredCreatives.filter((filteredCreative) => filteredCreative !== clickedCreative)
      } else {
        this.filteredCreatives.push(clickedCreative)
      }
      this.combineFilters()
    },
    dateFilter (clickedDate) {
      if (this.filteredDates.includes(clickedDate)) {
        this.filteredDates = this.filteredDates.filter((filteredDate) => filteredDate !== clickedDate)
      } else {
        this.filteredDates.push(clickedDate)
      }
      this.combineFilters()
    },
    combineFilters () {
      this.isLoading = true
      if (this.filteredDates.length > 0) {
        this.filteredResults = this.assignedResults.filter((shot) => this.filteredDates.some(filteredDate => shot.Name === filteredDate))
      } else {
        this.filteredResults = this.assignedResults
      }
      if (this.filteredCreatives.length > 0) {
        this.filteredResults = this.filteredResults.filter((shot) => this.filteredCreatives.some(filteredCreative => shot.PHOTOG_Full_Name && shot.PHOTOG_Full_Name.split(',').includes(filteredCreative)))
      }
      this.isLoading = false

      // this is the end of the shot processing so here we check for jump
      // added bonus - if a filter invalidates the now, like you filter by yesterday, it disappears
      this.jumpNow(true)
    },
    getDayofWeek (date) {
      let dateVal = new Date(date)
      let dayInt = dateVal.getUTCDay()
      let week = ['sun', 'mon', 'tue', 'wed', 'thur', 'fri', 'sat']
      if (isNaN(dayInt) && dayInt < 7) {
        return ''
      } else {
        return week[dayInt]
      }
    },
    backToTop () {
      // this one is needed for safari apparently
      document.body.scrollTop = 0
      // for all other browsers
      document.documentElement.scrollTop = 0
    },
    getZohoShotlist (force = false) {
      this.isLoading = true
      let forceParam = ''
      if (force) {
        forceParam = '/force'
      }
      axios
        .get(apiChoice + 'api/zohoshotsforjob/' + this.zohoId + forceParam, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          // this.zohoJobs = response.data.data
          if (Object.keys(response.data).length === 0) {
            this.noShots = true
          }
          this.cachedon = 'cachedon' in response.data ? this.parseDate(response.data.cachedon.split(' ')[0]) + ' ' + this.amPmConvert(response.data.cachedon.split(' ')[1]) : ''

          if (response.data.hasOwnProperty('data')) {
            // regex for date format
            // /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}?$/
            // this.zohoData = response.data.data
            this.shots = response.data.data
            this.processShots()
            this.zohoWorks = true
          } else {
            this.noShots = true
            // this.zohoError = 'error_description' in response.data ? response.data.error_description : JSON.stringify(response.data)
            // console.log(response.data)
            // this.zohoWorks = false
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    toggleTab (tab) {
      this.activeTab = tab
    },
    processShots () {
      // END_TIME: Anytime
      // START_TIME: Anytime
      // PHOTOG: as available
      // Name: ANY DAY
      let creativesArray = []
      this.shots.forEach((shot) => {
        if (shot.ESTIMATED_TIME) {
          shot.ESTIMATED_TIME = shot.ESTIMATED_TIME.replace(/\n/g, '</p><p style="margin-top: 12px;">')
          shot.ESTIMATED_TIME = '<p>' + shot.ESTIMATED_TIME + '</p>'
        }
        if (shot.ANY_SPECIAL_DELIVERY_INSTRUCTIONS_REQUIREMENTS) {
          shot.ANY_SPECIAL_DELIVERY_INSTRUCTIONS_REQUIREMENTS = shot.ANY_SPECIAL_DELIVERY_INSTRUCTIONS_REQUIREMENTS.replace(/\n/g, '</p><p style="margin-top: 12px;">')
          shot.ANY_SPECIAL_DELIVERY_INSTRUCTIONS_REQUIREMENTS = '<p>' + shot.ANY_SPECIAL_DELIVERY_INSTRUCTIONS_REQUIREMENTS + '</p>'
        }
        // ensure the required keys are present for notes component
        if (!('appshotid' in shot)) {
          shot.appshotid = 0
        }
        if (!('usernote' in shot)) {
          shot.usernote = ''
        }

        // divide general and assigned
        if (!/\d/.test(shot.END_TIME) || !/\d/.test(shot.START_TIME) || !shot.PHOTOG || !shot.PHOTOG.includes('@') || !/\d/.test(shot.Name)) {
          this.generalResults.push(shot)
        } else {
          this.assignedResults.push(shot)
        }
        if (shot.PHOTOG_Full_Name) {
          // no spaces from zoho between commas
          // let shotCreativeArray = shot.PHOTOG_Full_Name.replace(/\s+/g, '') // remove spaces
          let shotCreativeArray = shot.PHOTOG_Full_Name.split(',') // convert into an array
          shotCreativeArray.forEach((creative) => {
            if (creative && !creativesArray.includes(creative)) {
              creativesArray.push(creative)
            }
          })
        }
        if (/\d/.test(shot.Name)) {
          if (!this.eventData.days.includes(shot.Name)) {
            this.eventData.days.push(shot.Name)
          }
        }
      })
      if (this.assignedResults < 1) {
        this.activeTab = 'general'
      }
      this.eventData.creatives = creativesArray.join(',')
      this.combineFilters()
    },
    scrollpastfilters (scroll) {
      let element = document.getElementById('shotlist-container')
      if (element) {
        let filterThreshold = element.offsetTop - 100
        if (window.scrollY > filterThreshold) {
          this.showFilterToggle = true
        } else {
          this.showFilterToggle = false
        }
      }
    },
    toggleExpand (index) {
      this.$set(this.isExpanded, index, !this.isExpanded[index])
    },
    updateShot (emitted, index, type) {
      // this is for when you switch tabs between assigned and general then go back to assigned, newly added notes/checks will disappear because the component refreshes but the api call has not, and the update is kept in the component, so this also updates the array from the api response

      // checks emit a string, notes emit an object to send out both the note content and the app's id for the new shot so follow up updates can put instead of post a new one
      if (type === 'note') {
        this.filteredResults[index]['usernote'] = emitted.extraone
        this.filteredResults[index]['appshotid'] = emitted.id
      } else if (type === 'check') {
        this.generalResults[index]['usernote'] = emitted.extraone
        this.generalResults[index]['appshotid'] = emitted.id
      }
    },
    pmPlus12 (time) {
      let hourAsNum = Number(time.split(':')[0])
      if (time.toLowerCase().includes('pm')) {
        hourAsNum += 12
      }
      return hourAsNum.toString().padStart(2, '0') + ':' + time.split(':')[1]
    },
    jumpNow (justChecking = false) {
      let now = new Date()
      let todaystring = now.toLocaleDateString('en-CA')
      let timestring = now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes()

      // for testing
      // todaystring = '2025-03-30'
      // timestring = '12:15 AM'

      let indexOfNowShot = this.filteredResults.findIndex((element) => this.parseDate(element.Name) === this.parseDate(todaystring) && this.pmPlus12(element.START_TIME) > timestring) - 2

      console.log('in')
      console.log(indexOfNowShot)

      // negative find result is -1
      if (indexOfNowShot >= 0) {
        if (justChecking) {
          this.jobIsCurrent = true
        } else {
          let idOfNowShot = 'assigned-' + indexOfNowShot
          let nowShot = document.getElementById(idOfNowShot)
          if (nowShot) {
            nowShot.scrollIntoView()
          }
        }
      } else {
        this.jobIsCurrent = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.tab-content .menu-info{
  h2{
    display: block;
  }
}
.desktop-button{
  display: none;
}
.mobile-button {
  display: flex;
  &.csv-fab{
    right: 100px;
  }
}

// sticky items
.shot-back-button-container{
  position: sticky;
  top: 0px;
  z-index: 10;
  background: $color-bg-1;
}
.filters-container.sticky-filters-container{
  position: sticky;
  top: 76px;
  z-index: 10;
  box-shadow: 0px 8px 12px -8px rgba(0,0,0,0.1);
  background: $color-bg-1;
}
// original styles moved to container based
.shot-back-row{
  padding-top: 24px;
  margin-top: -24px;
  z-index: 10;
  background: $color-bg-1;
}
.shot-sticky-creatives{
  position: sticky;
  top: 76px;
  z-index: 10;
  background: $color-bg-1;
}
.shot-sticky-dates{
  position: sticky;
  top: 154px;
  z-index: 10;
  background: $color-bg-1;
  box-shadow: 0px 8px 12px -8px rgba(0,0,0,0.1);
}
.show-filters-button-container{
  position: sticky;
  top: 0px;
  z-index: 25;
  padding-top: 24px;
  margin-top: -80px;
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .desktop-button{
    display: inline-block;
  }
  .mobile-button {
    display: none;
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
